import { Route } from '~/features/workflow-routing/types';
import { everest } from '~/services/serviceInstances';

import {
  ServerRoutingResponse,
  UpdateRoutingApiArg,
} from '../../types/routings/routes';

type Request = UpdateRoutingApiArg;

export const updateRouting = async ({
  routingId,
  routingUpdateInput,
}: Request): Promise<Route> => {
  const response: ServerRoutingResponse = await everest.put(
    `/routing/${routingId}`,
    routingUpdateInput,
  );

  return {
    id: response.id,
    workflowId: response.workflowId,
    routeName: response.routeName,
    status: response.status,
    instructions: response.instructions,
    createdDate: response.createdDate,
    modifiedDate: response.modifiedDate,
    createdById: response.createdById,
    modifiedById: response.modifiedById,
    versionNumber: response.versionNumber,
    createdByName: response.createdByName ?? null,
    modifiedByName: response.modifiedByName ?? null,
    publishedWorkflowId: response.publishedWorkflowId ?? null,
  };
};
